
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i-cloud-drive",
      function () {
        return require("private-next-pages/i-cloud-drive/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i-cloud-drive"])
      });
    }
  